<template>
  <EmTooltip title="Copy to Clipboard" location="bottom">
    <template #activator="{ props: slotProps }">
      <a v-bind="slotProps" class="bold text-primary-lighten-2 cursor-pointer" @click.stop.prevent="copySupportEmail">
        <slot>
          {{ supportEmail }}
        </slot>
      </a>
    </template>
  </EmTooltip>
</template>

<script setup>
const { supportEmail } = useContactEmails()
const { copyToClipboard } = useDeviceStore()
const copySupportEmail = async () => {
  await copyToClipboard({
    value: supportEmail, text: supportEmail
  })
}
</script>
